export enum MailRecipientsType {
    TO = "to",
    CC = "cc",
    BCC = "bcc",
    SUBJECT = "subject"
}